/**
 * Divider — DS Atom
 */

import styles from './Divider.module.css';

interface DividerProps {
  label?: string;
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}

export function Divider({ label, orientation = 'horizontal', className = '' }: DividerProps) {
  if (orientation === 'vertical') {
    return <div className={`${styles.vertical} ${className}`} />;
  }
  if (label) {
    return (
      <div className={`${styles.withLabel} ${className}`}>
        <div className={styles.line} />
        <span className={styles.labelText}>{label}</span>
        <div className={styles.line} />
      </div>
    );
  }
  return <hr className={`${styles.horizontal} ${className}`} />;
}
